import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../hooks/reduxHooks';
import { useRoutePrefix } from '../../../hooks/useRoutePrefix';

/**
 * Lleva al detalle del establecimiento, donde cada bloque de datos tiene su
 * botón "Editar". Lo usan las correcciones que "se corrigen en
 * Establecimientos" (mail, teléfono, CIIU, CUIL del contacto…).
 *
 * El establecimiento es el seleccionado en el store: el mismo con el que se
 * entró a sus presentaciones y al informe. Sin uno, devuelve null y la
 * etiqueta queda sin link.
 */
const useIrAEditarEstablecimiento = (): (() => void) | null => {
    const navigate = useNavigate();
    const routePrefix = useRoutePrefix();
    const idEstablecimiento = useAppSelector(
        (state) => state?.establishment?.selectedEstablishmentId
    );

    if (!idEstablecimiento) return null;

    return () =>
        navigate(`/${routePrefix}/establecimientos/detalle`, {
            state: { selectedEstablishment: { id: idEstablecimiento } }
        });
};

export default useIrAEditarEstablecimiento;
